import { httpService } from "../../HttpService";
import { Result } from "../../../models/Result";

type FastPayFeatureFlags = Record<string, boolean>;

let flagCache: { flags: FastPayFeatureFlags; fetchedAt: number } | null = null;
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

class FastPayFeatureFlagService {
    private readonly path: string = "MerchantVendor";

    private fetchFlags = async (): Promise<FastPayFeatureFlags> => {
        if (flagCache && Date.now() - flagCache.fetchedAt < CACHE_TTL_MS) {
            return flagCache.flags;
        }

        try {
            const result: Result<FastPayFeatureFlags> = await httpService.get<FastPayFeatureFlags>(
                `${this.path}/fastpay-feature-flags`
            );

            if (result.success && result.data && Object.keys(result.data).length > 0) {
                flagCache = { flags: result.data, fetchedAt: Date.now() };
                return result.data;
            }

            return {};
        } catch {
            return {};
        }
    };

    isEnabled = async (flagName: string): Promise<boolean> => {
        const flags = await this.fetchFlags();
        return flags[flagName] === true;
    };
}

const fastPayFeatureFlagService = new FastPayFeatureFlagService();
export { fastPayFeatureFlagService };
